export default function AdminContentLoading({ active, isDarkMode, label = "Loading content...", fullscreen = false }) {
  if (!active) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className={`${fullscreen ? "fixed inset-0 z-[60]" : "absolute inset-0 z-10 rounded-lg"} flex items-center justify-center backdrop-blur-[2px] ${isDarkMode ? "bg-slate-950/70 text-white" : "bg-white/80 text-slate-700"}`}
    >
      <div className="flex items-center gap-3 rounded-xl border border-slate-400/20 bg-inherit px-5 py-4 shadow-sm">
        <span aria-hidden="true" className="h-5 w-5 rounded-full border-2 border-current border-t-transparent motion-safe:animate-spin" />
        <span className="text-sm font-medium">{label}</span>
      </div>
    </div>
  );
}
